import React from "react";
import Layout from "./layout.js";
import Breadcrumbs from "../component/Breadcrumbs.js";
import ServicesListSection from "../component/ServicesListSection.js";
import SectionHeading from "../component/SectionHeading.js";
import * as Constants from "../config/constants.js";

export default function Services({ pageName }) {
  // ✅ Canonical URL for services listing page
  const canonicalUrl = `${Constants.SITE_URL}/services/`;

  // ✅ SEO for services overview page
  const seoData = {
    seo_title: pageName,
    seo_description:
      "Consulting services for boutique consulting firms and independent consultants including hybrid delivery model consulting, consulting execution support, analytics, and end-to-end consulting solutions.",
    seo_keywords:
      "scaling consulting business, growth strategy consulting, boutique consulting firms, independent consultants, consulting execution partner, hybrid delivery model consulting, consulting lifecycle management, end-to-end consulting solutions, consulting delivery framework, implementation consulting services, consulting execution support",
    canonical_url: canonicalUrl,
  };

  return (
    <Layout pageName={pageName} seoData={seoData} pageUrl={canonicalUrl}>
      <Breadcrumbs
        title={pageName}
        text="Consulting delivery and project support for boutique consulting firms"
      />

      <section className="our-approach-sec sec-padding">
        <div className="container">
          <SectionHeading secName="OUR APPROACH" secText="FAIR Framework" />

          <div className="row approach-row">
            <div className="col-lg-3 col-sm-6">
              <div className="approch-card">
                <div className="icon-div">F</div>
                <div className="text-div">
                  <h5 className="title">Frame</h5>
                  <p className="p-text">Researching, Diagnosing, Benchmarking</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="approch-card">
                <div className="icon-div">A</div>
                <div className="text-div">
                  <h5 className="title">Assess</h5>
                  <p className="p-text">Structuring, Analyzing, Evaluating</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="approch-card">
                <div className="icon-div">I</div>
                <div className="text-div">
                  <h5 className="title">Innovate</h5>
                  <p className="p-text">Solutioning, Recommending & Strategizing</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="approch-card">
                <div className="icon-div">R</div>
                <div className="text-div">
                  <h5 className="title">Realize</h5>
                  <p className="p-text">Implementing, Supporting, Monitoring</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ServicesListSection secText="Consulting Practice Areas" />

    </Layout>
  );
}

